import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { Router } from "@angular/router";
import { NavigationItem } from "@interfaces/navigation-item";
import { Store } from "@ngrx/store";
import { selectUrl } from "@state/selectors/router.selectors";

@Component({
  selector: "app-side-navigation",
  templateUrl: "./side-navigation.component.html",
  styleUrls: ["./side-navigation.component.scss"]
})
export class SideNavigationComponent implements OnChanges {
  @Input() navigation: NavigationItem[] = [];

  currentUrl = this.store.selectSignal(selectUrl);

  constructor(
    private store: Store,
    private router: Router
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["navigation"]) {
      const navigation: NavigationItem[] = changes["navigation"].currentValue;

      this.navigation = navigation.map((nav) => ({
        ...nav,
        href: !nav.href.startsWith("/") ? `/${nav.href}` : nav.href
      }));
    }
  }

  navigate(nav: NavigationItem) {
    if (nav.disabled) {
      nav.onDisabledClick?.();
    } else {
      this.router.navigate([nav.href]);
    }
  }

  active(nav: NavigationItem) {
    return this.currentUrl().split("?")[0] === nav.href;
  }
}
